import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${window.location.origin}/api`;

export const useFeedbackData = (filters) => {
  const [reports, setReports] = useState([]);
  const [stats, setStats] = useState(null);
  const [flaggedStaff, setFlaggedStaff] = useState([]);
  const [blacklist, setBlacklist] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchReports = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};
      if (filters.staff_username) params.staff_username = filters.staff_username;
      if (filters.severity) params.severity = filters.severity;
      if (filters.feedback_type) params.feedback_type = filters.feedback_type;
      if (filters.status) params.status = filters.status;

      const [reportsRes, statsRes, flaggedRes] = await Promise.all([
        axios.get(`${API}/feedback-reports`, { params }),
        axios.get(`${API}/feedback-reports/stats`),
        axios.get(`${API}/feedback-reports/flagged-staff`),
      ]);
      setReports(reportsRes.data);
      setStats(statsRes.data);
      setFlaggedStaff(flaggedRes.data);
    } catch {
      toast.error("Failed to load feedback data");
    } finally {
      setLoading(false);
    }
  }, [filters]);

  const fetchBlacklist = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/feedback-blacklist`);
      setBlacklist(res.data);
    } catch {
      toast.error("Failed to load blacklist");
    }
  }, []);

  const fetchStaffList = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/staff?limit=100`);
      setStaffList(res.data);
    } catch {
      toast.error("Failed to load staff list");
    }
  }, []);

  useEffect(() => {
    fetchReports();
    fetchBlacklist();
    fetchStaffList();
  }, [fetchReports, fetchBlacklist, fetchStaffList]);

  return {
    reports,
    stats,
    flaggedStaff,
    blacklist,
    staffList,
    loading,
    refetchReports: fetchReports,
    refetchBlacklist: fetchBlacklist,
    refetchStaffList: fetchStaffList,
  };
};
